<template>
  <div class="acts-filter filters-container">
    <select-filter
      type="acts"
      field="status"
      label="Статус"
      request="objectInfo/act_statuses"
      :parse-value="({ name }) => name"
    />
    <sorting-control
      style="margin-left: 32px;"
      type="acts"
      :values="sortingFields"
    />
    <acts-mode-control
      v-if="!all"
      style="margin-left: 32px;"
    />
  </div>
</template>

<script>
import SelectFilter from './helpers/select-filter'
import SortingControl from './helpers/sorting-control'
import ActsModeControl from './helpers/acts-mode-control'

const sortingFields = [
  { field: 'number', name: 'Номер' },
  { field: 'send_date', name: 'Дата отправки' },
  { field: 'sign_date', name: 'Дата подписания' }
]

export default {
  props: ['all'],
  components: {
    SelectFilter,
    SortingControl,
    ActsModeControl
  },
  data () {
    return {
      sortingFields
    }
  }
}
</script>

<style></style>
